import "./Showcase.module.css";
import Header from "@/reusable_sections/Header";
import ProjectGallery from "./sections/ProjectGallery";
import ReadyToForge from "./sections/ReadyToForge";
import Footer from "@/reusable_sections/Footer";
export default function ShowcasePage() {
  return <div>
      <Header />
      <ProjectGallery />
      <ReadyToForge />
      <Footer />
    </div>;
}